import React from 'react';

import { EFFECTIVE_DATE_COPY } from '../../effectiveDateCopy';
import { formatEffectiveDate } from '../../effectiveDateRules';

interface EffectiveDateBannerProps {
  newCoverageStartDate: string;
  previousCoverageStartDate?: string;
  /** Omitted when the date is not editable here. */
  onChangeDate?: () => void;
  onDismiss: () => void;
}

// MET-468: shown after the quote page moved a lapsed effective date to today.
const EffectiveDateBanner: React.FC<EffectiveDateBannerProps> = ({
  newCoverageStartDate,
  previousCoverageStartDate,
  onChangeDate,
  onDismiss
}) => {
  const newDate = formatEffectiveDate(newCoverageStartDate);
  if (!newDate) return null;
  const previousDate = formatEffectiveDate(previousCoverageStartDate);

  return (
    <div
      className="effective-date-banner bg-yellow-50 border border-yellow-300 text-yellow-900 px-4 py-3 rounded-2xl mb-4 flex items-start justify-between"
      role="status"
      data-testid="effective-date-banner"
    >
      <p>
        <strong>{EFFECTIVE_DATE_COPY.bannerHeadline(newDate)}</strong>{' '}
        {previousDate ? (
          <>{EFFECTIVE_DATE_COPY.bannerPastDate(previousDate)} </>
        ) : null}
        {EFFECTIVE_DATE_COPY.bannerReview}
        {onChangeDate ? (
          <>
            {' '}
            <button
              type="button"
              className="underline font-bold text-secondary"
              data-testid="effective-date-banner-change-date"
              onClick={onChangeDate}
            >
              {EFFECTIVE_DATE_COPY.bannerChangeDate}
            </button>
          </>
        ) : null}
      </p>
      <button
        type="button"
        className="ml-4 flex-shrink-0 font-bold"
        aria-label={EFFECTIVE_DATE_COPY.bannerDismissLabel}
        data-testid="effective-date-banner-dismiss"
        onClick={onDismiss}
      >
        ×
      </button>
    </div>
  );
};

export default EffectiveDateBanner;
